import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import CashierPage from 'modules/restaurant/cashier/CashierPage';

export default function DashRestaurantCashier() {
    return (
        <DashContainer title='Caixa'>
            <CashierPage />
        </DashContainer>
    );
}
